import { Checkbox } from '@/components/ui/checkbox';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { useNlWkrEnabled } from '@/hooks/useNlWkr';
import { useTranslation } from '@/hooks/useTranslation';

/**
 * The per-line "WKR" checkbox — same shape and slot as the Incl / RC
 * checkboxes in InvoiceLineItems' tax cell. Checking it reveals the category
 * sub-row below the line (exemption-reason pattern). Self-gates on
 * flag + NL jurisdiction like WkrCategorySelect.
 */
interface WkrLineToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export function WkrLineToggle({ checked, onChange, disabled }: WkrLineToggleProps) {
  const { t } = useTranslation();
  const { enabled, isLoading } = useNlWkrEnabled();

  if (!enabled || isLoading) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <label className="flex items-center gap-1 cursor-pointer">
          <Checkbox
            checked={checked}
            onCheckedChange={(next) => onChange(next === true)}
            disabled={disabled}
            className="h-3.5 w-3.5"
          />
          <span className="text-[10px] text-muted-foreground select-none">
            {t('tax.nl.wkr.lineToggle')}
          </span>
        </label>
      </TooltipTrigger>
      <TooltipContent>{t('tax.nl.wkr.selectLabel')}</TooltipContent>
    </Tooltip>
  );
}
